import React from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const Home_Portfolio_Skeleton = ({ count = 1 }) => {
  return (
    <Row className="">
      {[...Array(count)].map((_, index) => (
        <React.Fragment key={index}>
          {/* Header Skeleton */}
          <Col xxl={3} xl={3} lg={3} md={6} sm={12} xs={12}>
            <Card
              className="finance_home_capital"
              style={{
                borderLeft: "2px solid #F1F4F7",
                borderRight: "0",
                borderTop: "0",
                borderBottom: "0",
              }}
            >
              <CardBody className="d-flex align-items-center">
                <div>
                  <h3 className="text-dark m-0 mb-2">
                    <Skeleton width={120} />
                  </h3>
                  <p
                    className="fs-12 text-muted fw-semibold mb-1"
                    style={{ letterSpacing: "1px" }}
                  >
                    <Skeleton width={80} />
                  </p>
                </div>
              </CardBody>
            </Card>
          </Col>

          {/* Debit Skeleton */}
          <Col xxl={3} xl={3} lg={3} md={6} sm={12} xs={12}>
            <Card className="home_finance_card border-0">
              <CardBody className="d-flex align-items-center">
                <div>
                  <h4 className="text-dark m-0 mb-2">
                    <span className="fs-16 fw-medium text-muted me-2">₹</span>
                    <Skeleton width={100} />
                  </h4>
                  <p
                    className="fs-12 text-muted fw-semibold mb-1"
                    style={{ letterSpacing: "1px" }}
                  >
                    <Skeleton width={60} />
                  </p>
                </div>
              </CardBody>
            </Card>
          </Col>

          {/* Credit Skeleton */}
          <Col xxl={3} xl={3} lg={3} md={6} sm={12} xs={12}>
            <Card className="home_finance_card border-0">
              <CardBody className="d-flex align-items-center">
                <div>
                  <h4 className="text-dark m-0 mb-2">
                    <span className="fs-16 fw-medium text-muted me-2">₹</span>
                    <Skeleton width={100} />
                  </h4>
                  <p
                    className="fs-12 text-muted fw-semibold mb-1"
                    style={{ letterSpacing: "1px" }}
                  >
                    <Skeleton width={60} />
                  </p>
                </div>
              </CardBody>
            </Card>
          </Col>

          <Col xxl={3} xl={3} lg={3} md={6} sm={12} xs={12}>
            <Card className="home_finance_card border-0">
              <CardBody className="d-flex align-items-center">
                <div>
                  <h4 className="text-dark m-0 mb-2">
                    <span className="fs-16 fw-medium text-muted me-2">₹</span>
                    <Skeleton width={100} />
                  </h4>
                  <p
                    className="fs-12 text-muted fw-semibold mb-1"
                    style={{ letterSpacing: "1px" }}
                  >
                    <Skeleton width={60} />
                  </p>
                </div>
              </CardBody>
            </Card>
          </Col>
        </React.Fragment>
      ))}
    </Row>
  );
};

export default Home_Portfolio_Skeleton;
